export const ClaimManagerEvents = {
  SubmitNFT: 'ClaimManager.SubmitNFT',
  SubmitNFTCompleted: 'ClaimManager.SubmitNFTCompleted',

  RedeemNFT: 'ClaimManager.RedeemNFT',
  RedeemNFTCompleted: 'ClaimManager.RedeemNFTCompleted',

  RedeemClaim: 'ClaimManager.RedeemClaim',
  RedeemClaimCompleted: 'ClaimManager.RedeemClaimCompleted',
}
